const HOMEPAGE_FAQS = [
    {
        question: "Who is ENA Connect Direct for?",
        answer: "Connect Direct is for domestic low-carbon installers. It is used to get approval to connect these technologies to the grid. In addition, it holds data about the LCT models available on the UK market to allow automation of connection applications",
    },
    {
        question: "How much does it cost?",
        answer: "Nothing! ENA Connect Direct is free provided free of charge by the seven UK Distribution Network Operators",
    },
    {
        question: "Where can I use ENA Connect Direct?",
        answer: "ENA Connect Direct is available for all UK domestic low-carbon technology installations",
    },
    {
        question:
            "Is Connect Direct for pre-installation or post-installation?",
        answer: "All Connect Direct applications must be submitted pre-installation",
    },
    {
        question: "What problem does ENA Connect Direct aim to solve?",
        answer: "Connect Direct digitalises the current paper-based connection process. Our vision is for Connect Direct to remove the friction from the LCT connections process, by connecting installers directly to the GB and NI DNOs, and by automating as much of the process as possible. This automation reduces the volume of information an installer needs to provide and uses machine-to-machine communication to speed up the process. The platform is capable of auto-approving applications, making it better, faster, and easier than the current paper-based process",
    },
]
export default HOMEPAGE_FAQS
